module.exports = __webpack_public_path__ + "img/dgdpr.ca9cf35.svg";